// Открытые сейчас заказы для «Загрузки кухни»: запрос раз в минуту, пока экран открыт, вкладка видна
// и период включает сегодняшний учётный день (useVisiblePolling). Бэкенд кеширует на 90 с (общий кеш
// сервера) и при сбое iikoCloud отдаёт последний ответ не старше 15 минут (stale); дольше — ошибка,
// и экран пишет «Живые данные недоступны с HH:MM» по времени последнего удачного ответа.
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { fetchKitchenLive } from '../../services/dataService';
import { useVisiblePolling } from './useVisiblePolling';
import { cacheKey, readCache, writeCache } from './kitchenCache';

const POLL_MS = 60 * 1000;

// filter — { restaurant, group } из выбора в шапке; объект стабилен, пока выбор не меняется (useMemo на странице)
export function useKitchenLive({ enabled, filter, server }) {
  const [live, setLive] = useState(null); // последний ответ бэкенда
  const [failed, setFailed] = useState(false);
  const lastUpdatedRef = useRef(null); // updated_at последнего удачного ответа — для «недоступны с»
  const requestRef = useRef(0); // ответ на устаревший запрос (сменился выбор ресторана или группы) не применяем

  const token = localStorage.getItem('token');
  const key = useMemo(() => cacheKey('live', token, server, filter), [token, server, filter]);

  const load = useCallback(async () => {
    if (!token) return;
    const request = ++requestRef.current;
    try {
      const data = await fetchKitchenLive(token, filter);
      if (request !== requestRef.current) return;
      setLive(data);
      writeCache(key, data);
      setFailed(false);
      lastUpdatedRef.current = data.updated_at || lastUpdatedRef.current;
    } catch {
      if (request === requestRef.current) setFailed(true);
    }
  }, [token, filter, key]);

  useEffect(() => {
    setLive(enabled ? readCache(key) : null); // прежний ответ по этому выбору — сразу, свежий подменит
    setFailed(false);
    if (enabled && document.visibilityState === 'visible') load();
  }, [enabled, key, load]);

  useVisiblePolling(enabled, POLL_MS, load);

  return { live, failed, lastUpdated: lastUpdatedRef.current };
}
